import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import QuantitySelector from '~/components/Layout/Cart/AddToCart/QuantitySelector.vue';
import useRightPath from '~/composables/useRightPath';
import useUiState from '~/composables/useUiState';
import { useGetTranslations } from '@/composables/useGetTranslations';
import AzImg from '~/components/Atoms/AzImg.vue';
import PriceDisplay from '~/components/Atoms/PriceDisplay.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'CartProduct',
  props: {
    product: {
      type: Object,
      default: function _default() {}
    },
    image: {
      type: String,
      required: true
    },
    price: {
      type: [String, Number],
      required: true
    },
    specialPrice: {
      type: [String, Number],
      default: undefined
    },
    title: {
      type: String,
      required: true
    },
    variant: {
      type: String,
      required: true
    },
    quantity: {
      type: [Number, String],
      default: 1
    },
    id: {
      type: String,
      required: true
    },
    slug: {
      type: String,
      required: true
    },
    useUrl: {
      type: Boolean
    },
    imageFixedSize: {
      type: Number,
      default: null
    },
    fullPrice: {
      type: Object,
      default: function _default() {
        return {
          regular: 0
        };
      }
    },
    minimumQuantity: {
      type: Number,
      default: 0
    },
    isOutOfStock: {
      type: Boolean,
      default: false
    },
    isExpressDeliveryCompatible: {
      type: Boolean
    },
    isGift: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update', 'remove'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var InformationBox = function InformationBox() {
      return import('~/components/Molecules/InformationBox.vue');
    };
    var InformationItem = function InformationItem() {
      return import('~/components/Molecules/InformationItem.vue');
    };

    // Types

    var isDiscount = computed(function () {
      return props.price !== props.specialPrice;
    });
    var discountedPrice = computed(function () {
      return isDiscount.value ? props.specialPrice : 0;
    });
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app;
    var _useRightPath = useRightPath(),
      getProductPath = _useRightPath.getProductPath;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var _useUiState = useUiState(),
      toggleCartSidebar = _useUiState.toggleCartSidebar;
    var getUrl = function getUrl() {
      return app.localePath(getProductPath({
        slug: props.slug
      }));
    };
    var selectedComponent = computed(function () {
      return props.useUrl ? 'NuxtLink' : 'div';
    });
    return {
      __sfc: true,
      InformationBox: InformationBox,
      InformationItem: InformationItem,
      props: props,
      emit: emit,
      isDiscount: isDiscount,
      discountedPrice: discountedPrice,
      app: app,
      getProductPath: getProductPath,
      translate: translate,
      toggleCartSidebar: toggleCartSidebar,
      getUrl: getUrl,
      selectedComponent: selectedComponent,
      AzIcon: AzIcon,
      QuantitySelector: QuantitySelector,
      AzImg: AzImg,
      PriceDisplay: PriceDisplay
    };
  }
});